import type { FieldValues } from 'react-hook-form';

export const SCS_PROFESSION_MATCH_ERROR =
  'Your secondary profession cannot be the same as your primary profession';

const PROFESSION_FIELDS = {
  primary: 'person-details-profession-primary',
  secondary: 'person-details-profession-secondary',
  primaryFunctional: 'person-details-profession-primary-functional',
  secondaryFunctional: 'person-details-profession-secondary-functional',
  primarySpecialist: 'person-details-profession-primary-specialist',
  secondarySpecialist: 'person-details-profession-secondary-specialist',
} as const;

const answer = (answers: FieldValues, field: string): string => String(answers[field] || '').trim();

export const getScsProfessionValidationError = (answers: FieldValues): string | null => {
  const primary = answer(answers, PROFESSION_FIELDS.primary);
  const secondary = answer(answers, PROFESSION_FIELDS.secondary);

  if (!primary || !secondary || primary !== secondary) return null;

  if (primary === 'Functional professions') {
    const primaryChild = answer(answers, PROFESSION_FIELDS.primaryFunctional);
    const secondaryChild = answer(answers, PROFESSION_FIELDS.secondaryFunctional);
    return primaryChild && secondaryChild && primaryChild !== secondaryChild
      ? null
      : SCS_PROFESSION_MATCH_ERROR;
  }

  if (primary === 'Specialist professions') {
    const primaryChild = answer(answers, PROFESSION_FIELDS.primarySpecialist);
    const secondaryChild = answer(answers, PROFESSION_FIELDS.secondarySpecialist);
    return primaryChild && secondaryChild && primaryChild !== secondaryChild
      ? null
      : SCS_PROFESSION_MATCH_ERROR;
  }

  return SCS_PROFESSION_MATCH_ERROR;
};
